/* This is scalable data, just add the studio object to the studios array and it will
    be added to the studios component of the page without any extra code written.

    */
    
    const studios = [
        {
            name: 'Walt Disney',
            logo: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/6389/1266389-h-e81ea729b3a9',
            video: 'https://img1.hotstarext.com/video/upload/sources/r1/cms/animations/8n6fmv_1649420240209',
            backgroundImg: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/6174/1266174-i-5bf3b3468737',
            titleImg: 'https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/6181/1266181-t-7a65a69031c2',
        },
        {
            name: 'Pixar',
            logo: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/6392/1266392-h-d83d47e81650',
            video: 'https://img1.hotstarext.com/video/upload/sources/r1/cms/animations/kwup1_1649421095532',
            backgroundImg: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/6177/1266177-i-78bf856ff2fb',
            titleImg: 'https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/6184/1266184-t-3aa18647c7d9',
        },
        {
            name: 'Marvel Studios',
            logo: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/6390/1266390-h-2d1dd55861f8',
            video: 'https://img1.hotstarext.com/video/upload/sources/r1/cms/animations/20ojer_1649419122712',
            backgroundImg: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/6175/1266175-i-ad4370b97a7d',
            titleImg: 'https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/6182/1266182-t-db442c5a904a'
        },
        {
            name: 'National Geographic',
            logo: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/6391/1266391-h-35e4e676651a',
            video: 'https://img1.hotstarext.com/video/upload/sources/r1/cms/animations/364ygx_1649419839498',
            backgroundImg: 'https://img1.hotstarext.com/image/upload/f_auto/sources/r1/cms/prod/6176/1266176-i-289ac507db12',
            titleImg: 'https://img1.hotstarext.com/image/upload/f_auto,t_web_hs_3x/sources/r1/cms/prod/6183/1266183-t-21a25c9f607b',
        },
    ]

export default studios;